<template>
  <div class="chat-bot-personal-data-agreement__wrapper">
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      frameborder="0"
      class="chat-bot-personal-data-agreement__wrapper__iframe"
    />
  </div>
</template>

<script>
import {mapState } from 'vuex';

export default {
  name: "ChatBotPersonalDataAgreement",

  data() {
    return {
      iframeUrl: null,
    };
  },

  computed: {
    ...mapState({
      siteIdentifier: (state) => state.config.mobileAppSettings.siteIdentifier,
    }),
  },

  created() {
    const bot = this.$route.query.bot;

    if (bot) {
      this.iframeUrl = `https://lk.dom-iks.ru/#/${this.siteIdentifier}/chat-bot-personal-data-agreement?bot=${bot}`;
    } else {
      console.error("Не указан идентификатор чат-бота");
    }
  },
};
</script>

<style>
.chat-bot-personal-data-agreement__wrapper {
  width: 100%;
  height: 100vh;
}

.chat-bot-personal-data-agreement__wrapper__iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
